export enum MercerSupportExperienceLevel {
  None = 'None',
  DevelopmentStep = 'DevelopmentStep',
  Experienced = 'Experienced',
  Incumbent = 'Incumbent'
}
